export const dialogContent = {
  padding: '20px',
  button: {
    padding: '0 0 2px 0',
  },
} as const;
